<template>
    <div class="newsDetail">

        <div class="main">
            <div class="title">{{ title }}</div>
            <div class="time">发布日期：{{ add_time }}</div>
            <!-- <div class="newsDetail-divider">
                <div></div>
            </div> -->
            <div class="content margin-top-30" v-html="content"></div>
        </div>
    </div>
</template>

<script>
import { getNewsdetails } from '../../api/api'
import detailNav from '../../components/detailNav'
import { mapGetters, mapMutations } from 'vuex'
export default {
    name: '',
    components: {
        detailNav
    },
    computed: {
        ...mapGetters({
            nav: 'getNav'
        })
    },
    data() {
        return {
            id: '',
            content: '',
            title: '',
            index: 0,
            add_time: '',
            source: '',
            author: ''
        }
    },
    methods: {
        getNewsdetails() {
            let data = {
                typeid: this.id
            }
            getNewsdetails(data).then(res => {
                if (res.code == 1) {
                    this.title = res.data.title
                    this.content = res.data.content
                    this.add_time = res.data.add_time
                    this.source = res.data.source
                    this.author = res.data.author
                }
            })
        },
        handleChange(index) {
            // this.info=this.list[index]
            this.$router.push({ path: '/News', query: { index: index } })
        }
    },
    mounted() {
        this.index = this.$route.query.index
        // console.log(this.index)
        // this.$refs.nav.setActive(this.index)
        this.id = this.$route.query.id
        this.getNewsdetails()
    }

}
</script>

<style lang="scss" scoped>
.newsDetail {
    width: 100%;

    .main {
        width: 1200px;
        margin: 40px auto 100px;

        .title {
            font-size: 32px;
            font-family: 'BlackFont';
            text-align: center;
            margin: 10px 0;
        }

        .time {
            font-size: 14px;
            color: rgba(71, 71, 71, 1);
            text-align: center;
        }

        :deep(img) {
            max-width: 1200px;
        }

        :deep(span) {
            font-family: 'MediumFont' !important;
        }
    }
}
</style>